<template>
  <div>
    <Modal :styles="{ top: '20px' }" :value="true" title="Driver Modal" :closable="false" :mask-closable="false"
      class="license-add-modal">
      <div slot="header" class="d-flex justify-content-between align-items-center">
        <h5 v-if="user">{{ $t('global.edit_user') }}</h5>
        <h5 v-else>{{ $t('club.table.add_user') }}</h5>
        <Button @click="close()" type="text" icon="md-close" class="modal-close-btn"></Button>
      </div>

      <Alert v-if="serverError.length" type="error"> {{ serverError }} </Alert>
      <Spin v-if="loading" fix>
        <Icon class="demo-spin-icon-load" size="40" type="ios-loading"></Icon>
        <div>{{ $t("global.loading") }}</div>
      </Spin>
      <Form v-else class="add-user-modal" ref="addDriverForm" :model="formValidate" :rules="ruleValidate"
        :label-width="130">

        <FormItem :label="$t('club.table.name')" prop="name">
          <Input v-model="formValidate.name" :placeholder="$t('club.table.name')"></Input>
        </FormItem>
        <FormItem :label="$t('club.password')" prop="password">
          <Input v-model="formValidate.password" type="password" :placeholder="$t('club.password')"></Input>
        </FormItem>
        <FormItem :label="$t('user.form.role')" prop="role">
          <Select v-model="formValidate.role" :placeholder="$t('user.form.role')">
            <Option v-for="(item, index) in roles" :value="item.role" :key="item.role + '-' + index">{{ item.title }}
            </Option>
          </Select>
        </FormItem>
        <FormItem v-if="formValidate.role === 'manager'" :label="$t('club.club')" prop="clubId">
          <Select v-model="formValidate.club" :placeholder="$t('club.club')">
            <Option v-for="item in clubs" :value="item._id" :key="item._id">{{ item.name }}
            </Option>
          </Select>
        </FormItem>

        <FormItem :label="$t('driver.description')" prop="comment">
          <Input v-model="formValidate.description" type="textarea" :placeholder="$t('driver.description')" />
        </FormItem>
      </Form>
      <div slot="footer" class="text-center">
        <ButtonGroup class="modal-footer-btn">
          <Button @click="handleSubmit('addDriverForm')" :loading="loading" type="success"
            style="min-width: 150px"><b>{{
      $t('global.save') }}</b></Button>
        </ButtonGroup>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: [
    'roles',
    'user'
  ],
  data() {
    return {
      modalDriver: false,
      serverError: "",
      loading: false,
      loginInput: true,
      deleteFileIndex: null,
      clubs: [],
      formValidate: {
        name: '',
        role: [],
        password: '',
        description: '',
        clubId: null,
        club: '',
      },
      ruleValidate: {
        name: [
          { required: true, message: 'The name cannot be empty', trigger: 'blur' }
        ],
        role: [
          { required: true, message: 'Please select the role', trigger: 'change' }
        ],
        password: [
          { required: true, message: 'The password cannot be empty', trigger: 'change' }
        ],
      }
    }
  },
  watch: {
    formValidate: {
      deep: true,
      handler(_value) {
        this.changes = true
        if (_value.role === 'manager')
          this.getClubs()
      }
    }
  },
  methods: {
    ok() {
      this.$Message.info('Clicked ok');
    },
    async getClubs() {
      if (this.formValidate.role === 'manager' && this.clubs.length === 0) {
        this.loading = true
        try {
          const res = await this.$http.post('/club/list', {})
          this.clubs = res.data
          console.log(res.data)
          this.loading = false
        } catch (err) {
          console.log(err)
          this.loading = false
        }
      }
    },
    close(_value) {
      if (this.changes === true) {
        this.$dialog
          .confirm(this.$t('global.changesNotSaved'), {
            okText: this.$t('global.next'),
            cancelText: this.$t('global.exit'),
            customClass: "mahnung-confirm",
            //reverse: true,
          })
          .then((_dialog) => {

          })
          .catch(() => {

            this.$refs['addDriverForm'].resetFields();
            this.$emit('close', 0)
          });
      } else {


        this.$refs['addDriverForm'].resetFields();
        this.$emit('close', 0)
      }
    },

    handler(event) {
      event.preventDefault();
      const contextMenuDelete = document.querySelector(".contextMenuDelete");
      const [type, id] = event.currentTarget.id.split("_");
      const itemTarget = event.currentTarget;
      this.deleteFileIndex = id;
      itemTarget.insertAdjacentElement("afterend", contextMenuDelete);
      contextMenuDelete.style.display = "block";
      document.addEventListener("click", () => {
        contextMenuDelete.style.display = "none";
      });
    },
    async deleteFile() {
      this.formValidate.files.splice(this.deleteFileIndex, 1);
      this.deleteFileIndex = null;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
    },
    handleSuccess(res, _file) {
      this.formValidate['files'].push(res.path)
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "The file format is incorrect",
        desc:
          "File format of " +
          file.name +
          " is incorrect, please select jpg or png.",
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    async submitForm() {

      this.loading = false;
      this.serverError = '';
      let type = 'register';
      if (this.user) type = 'edit'
      try {
        let response = await this.$http.post("/user/" + type, { ...this.formValidate, clubId: this.formValidate.club });
        if (response.status === 201) {
          if (!this.user) this.$refs['addDriverForm'].resetFields();
          this.$emit('updateList', 0)
          this.$Message.success('Success!');
        }
      } catch (e) {
        console.log(e)
        console.log(e.response.data)
        this.serverError = e.response.data.codes[0];
      }
    },
    // handleRating(event) {
    //   this.formValidate.rating = +event;
    //   console.log("formValidate.rating", this.formValidate.rating)
    // },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.loading = true
          await this.submitForm();
          setTimeout(() => {
            this.$emit('close');
          }, 700)
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    addAdditional(phone) {
      this.formValidate[phone].push("")
    },
    removeAdditional(phone, index) {
      this.formValidate[phone].splice(index, 1);
    },
  },
  async mounted() {
    this.loading = true
    if (this.user !== null) {
      const userObj = JSON.parse(JSON.stringify(this.user))
      let obj = {
        ...this.formValidate,
        ...userObj
      }
      obj.role = userObj.role[0]
      obj.password = '';
      let fields = Object.keys(this.formValidate)
      for (let i = 0; i < fields.length; i++) {
        const element = fields[i];
        if (obj.hasOwnProperty(element)) {
          this.formValidate[element] = obj[element]
        }
      }
      this.formValidate._id = obj._id
      this.formValidate.club = this.user.role.includes('manager') ? obj.clubId._id : null
      // this.formValidate = { ...obj };
      this.loginInput = false;
      delete this.ruleValidate.password;
      setTimeout(() => { this.changes = false }, 1000)
    }
    this.loading = false
    // this.formValidate.roles = this.roles;
  }
}
</script>

<style scoped>
/*.add-user-modal:global(.ivu-form .ivu-form-item) {*/
/*  margin-bottom: 0 !important;*/
/*}*/

.good-rating {
  background: #18BE6B !important;
  border-color: #18BE6B !important;
  color: #ffffff !important;
}

.average-rating {
  background: #FF9A01 !important;
  border-color: #FF9A01 !important;
  color: #ffffff !important;
}

.black-list-rating {
  background: #EE4014 !important;
  border-color: #EE4014 !important;
  color: #ffffff !important;
}

.good-rating:hover,
.good-rating:checked,
.good-rating:visited,
.good-rating:active {
  background: #19c36d !important;
  border-color: transparent !important;
  color: #ffffff;
}

.average-rating:hover,
.average-rating:checked,
.average-rating:visited,
.average-rating:active {
  background: #fbae3f !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

.black-list-rating:hover,
.black-list-rating:checked,
.black-list-rating:visited,
.black-list-rating:active {
  background: #f8582d !important;
  border-color: transparent !important;
  color: #ffffff !important;
}

.add-user-modal :global(.ivu-radio-group-button .ivu-radio-wrapper-checked.ivu-radio-focus) {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.add-user-modal :global(.ivu-radio-group-button .ivu-radio-wrapper-checked),
.add-user-modal :global(.ivu-radio-group-button .ivu-radio-wrapper-checked:first-child) {
  border-color: transparent !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.add-user-modal :global(.ivu-radio-group-button .ivu-radio-wrapper:after),
.add-user-modal :global(.ivu-radio-group-button .ivu-radio-wrapper:before) {
  content: none !important;
  background: transparent !important;
  display: none !important;
}

.rating-btn-group .checked-line {
  position: relative !important;
}

.rating-btn-group .ivu-radio-group-item {
  width: 119px;
  text-align: center;
}

.rating-btn-group .ivu-radio-wrapper-checked .checked-line:after {
  content: "";
  width: 100%;
  height: 2px;
  position: absolute;
  bottom: -3px;
  left: 0;
  right: 0;
  background: #ffffff !important;
  display: inline-block;
  margin: 0 auto;
  z-index: 99;
}

.add-user-modal :global(.ivu-form-item-error-tip) {
  padding-top: 2px;
}

ul.contextMenuDelete {
  display: none;
  z-index: 999;
  list-style: none;
  margin: 0;
  padding: 0;
  font: 300 15px "Roboto", sans-serif;
  position: absolute;
  right: 15px;
  color: #333;
  -webkit-box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.2);
}

ul.contextMenuDelete * {
  -webkit-transition: color 0.4s, background 0.4s;
  -o-transition: color 0.4s, background 0.4s;
  transition: color 0.4s, background 0.4s;
}

ul.contextMenuDelete li {
  overflow: hidden;
  white-space: nowrap;
  padding: 12px 30px;
  background-color: #fff;
  border-bottom: 1px solid #ecf0f1;
  cursor: pointer;
  text-align: center;
}

ul.contextMenuDelete li a {
  color: #333;
  text-decoration: none;
}

ul.contextMenuDelete li:hover {
  background-color: #ecf0f1;
}

ul.contextMenuDelete li i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 10px;
}

ul.contextMenuDelete li .fa-one {
  background: #ddfbe4;
}

ul.contextMenuDelete li .fa-zero {
  background: #f0f0f0;
}

ul.contextMenuDelete li .fa-two {
  background: #00a5e4;
}

ul.contextMenuDelete li .fa-three {
  background: #f0f0f0;
}

ul.contextMenuDelete li .fa-four {
  background: #f59191;
}

.phone-input-style .type-error-btn,
.phone-input-style .type-info-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  color: #ffffff;
  padding: 5px 15px;
}

.phone-input-style .type-error-btn {
  background-color: #EE4014;
}

.phone-input-style .type-info-btn {
  background-color: #2DB7F6;
}

.add-user-modal :global(.ivu-form-item) {
  margin-bottom: 15px;
}

.add-user-modal ul.contextMenuDelete {
  right: -50px;
  top: 35px;
}

.modal-close-btn {
  padding: 0 5px;
  font-size: 20px;
}

.upload-file-btn :global(.ivu-icon) {
  color: #2DB7F7;
  font-weight: bold;
}

.add-form-modal :global(.ivu-form-item) {
  margin-bottom: 10px;
}

.license-add-modal :global(.ivu-form-item-label) {
  padding: 5px 12px 5px 0;
  margin-bottom: 0;
}

.license-add-modal :global(.ivu-card-head p) {
  font-size: 13px;
  color: #495057;
}
</style>



// WEBPACK FOOTER //
// src/components/user/UserForm.vue